module.exports = __webpack_public_path__ + "static/img/product2-1.bf5aa9c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product2-1.jpg
// module id = Ayl1
// module chunks = 0